module.exports = __webpack_public_path__ + "img/phone3.1fbc8969.png";